import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "./pages/credentials/Login";
import ForgotPassword from "./pages/credentials/ForgotPassword";
import TwoFactorOTP from "./pages/credentials/TwoFactorOTP";
import PlanDetails from "./pages/dashboard/PlanDetails";
import CreatePlan from "./pages/dashboard/CreatePlan";
import UpgradePlan from "./pages/dashboard/UpgradePlan";
import PaymentMethods from "./pages/dashboard/PaymentMethods";
import ProtectedRoute from "./components/ProtectedRoute";
import StripeReturnPage from "./pages/dashboard/StripeReturnPage";

import "./styles/App.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="/stripe/return" element={<StripeReturnPage />} />
        <Route
          path="/otp-authentication"
          element={
            <ProtectedRoute>
              <TwoFactorOTP />
            </ProtectedRoute>
          }
        />
        <Route
          path="/plan-details"
          element={
            <ProtectedRoute>
              <PlanDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-plan"
          element={
            <ProtectedRoute>
              <CreatePlan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upgrade-plan"
          element={
            <ProtectedRoute>
              <UpgradePlan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment-methods"
          element={
            <ProtectedRoute>
              <PaymentMethods />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
  );
};

export default App;
